<template>
    <k-panel class="border">
        <k-panel-header slot="header">
            {{ $t("investmentDetails") }}
            <span>{{ investment.principalInvested | currencyFormat(currencySymbol) }}</span>
        </k-panel-header>
        <div v-if="investment.debentureCount === 0" class="text-gray-700 text-xs">
            {{ $t("noInvestmentsInTranche") }}
        </div>
        <div v-if="investment.debentureCount > 0">
            <k-panel-row>
                <div slot="left">Funded investments</div>
                <div slot="right">{{ investment.principalSettled | currencyFormat(currencySymbol) }}</div>
            </k-panel-row>
            <k-panel-row>
                <div slot="left">{{ $t("committedInvestments") }}</div>
                <div slot="right">
                    <div class="text-right">
                        {{ investment.principalSubscribed | currencyFormat(currencySymbol) }}
                    </div>
                    <div v-if="investment.principalSubscribed" class="text-right">
                        <a-popconfirm
                            title="Cancel committed investment?"
                            ok-text="Yes"
                            cancel-text="No"
                            @confirm="cancel()"
                        >
                            <a-button type="danger" ghost size="small" link>
                                {{ $t("cancel") }}
                            </a-button>
                        </a-popconfirm>
                    </div>
                </div>
            </k-panel-row>
        </div>

    </k-panel>
</template>

<script>
export default {
    props: {
        investment: {
            type: Object,
            required: true
        },
        currencySymbol: {
            type: String,
            required: true
        }
    },
    methods: {
        async cancel() {
            this.$emit('on-cancel');
        }
    }
};
</script>


